import { divIcon } from 'leaflet';

const deviceMarkerIconCache = new Map<string, ReturnType<typeof divIcon>>();

export const createDeviceMarkerIcon = (isSelected: boolean, isStale: boolean) => {
  const cacheKey = isSelected ? 'selected' : isStale ? 'stale' : 'active';
  const cachedIcon = deviceMarkerIconCache.get(cacheKey);
  if (cachedIcon) return cachedIcon;

  const color = isSelected ? '#16a34a' : isStale ? '#dc2626' : '#1d4ed8';

  const icon = divIcon({
    className: '',
    iconSize: [34, 50],
    iconAnchor: [17, 50],
    popupAnchor: [0, -42],
    html: `
      <div style="width:34px;height:50px;filter:drop-shadow(0 5px 10px rgba(15,23,42,.25));">
        <svg width="34" height="50" viewBox="0 0 34 50" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M17 1C8.16 1 1 8.16 1 17c0 11.16 11.98 26.95 15.13 30.9a1.09 1.09 0 0 0 1.74 0C21.02 43.95 33 28.16 33 17 33 8.16 25.84 1 17 1Z" fill="${color}" stroke="#ffffff" stroke-width="1.5"/>
          <circle cx="17" cy="17" r="4.8" fill="#ffffff"/>
        </svg>
      </div>
    `,
  });
  deviceMarkerIconCache.set(cacheKey, icon);
  return icon;
};
